/**
 * Längd-info (Petite/Regular) på combined PDP: popup efter variant-HTML byts (innerHTML körs inte om).
 */
(function () {
  if (window.cleanupPdpLengthNoticeOrphans && window.initPdpLengthNoticeIn) return;

  window.cleanupPdpLengthNoticeOrphans = function () {
    document.querySelectorAll('body > .custom-notice-overlay').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('body > .custom-notice-popup').forEach(function (el) {
      el.remove();
    });
  };

  function closeAllLengthNotices() {
    var anyOpen = false;
    document.querySelectorAll('.custom-notice-popup').forEach(function (popup) {
      if (popup.style.display === 'block') {
        anyOpen = true;
        popup.style.display = 'none';
      }
    });
    if (anyOpen) {
      document.querySelectorAll('.custom-notice-overlay').forEach(function (o) {
        o.style.display = 'none';
      });
      document.body.style.overflow = '';
    }
  }

  if (!window.__pdpLengthNoticeEscapeBound) {
    window.__pdpLengthNoticeEscapeBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllLengthNotices();
    });
  }

  window.initPdpLengthNoticeIn = function (scope) {
    var roots = (scope || document).querySelectorAll('.pdp-length-select[id^="LengthNotice--"]');
    roots.forEach(function (root) {
      var trigger = root.querySelector('.length-notice-trigger');
      var popup = root.querySelector('.custom-notice-popup');
      if (!trigger || !popup) return;
      if (root.dataset.lengthNoticePdpInit === 'true') return;
      root.dataset.lengthNoticePdpInit = 'true';

      var overlay = document.createElement('div');
      overlay.className = 'custom-notice-overlay';
      overlay.style.cssText =
        'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.15); display: none; z-index: 9998;';
      document.body.appendChild(overlay);

      var closeBtn = document.createElement('button');
      closeBtn.className = 'custom-notice-close';
      closeBtn.type = 'button';
      closeBtn.innerHTML =
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799"><g transform="translate(0.707 0.707)"><line x2="26" fill="none" stroke="#222" stroke-width="2" transform="translate(0 0) rotate(45)"></line><line x2="26" fill="none" stroke="#222" stroke-width="2" transform="translate(0 18.385) rotate(-45)"></line></g></svg>';
      closeBtn.style.cssText =
        'position: absolute; top: 20px; right: 20px; background: none; border: none; cursor: pointer; padding: 10px; z-index: 1;';

      popup.style.cssText =
        'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 40px; max-width: 90vw; width: 600px; max-height: 85vh; overflow-y: auto; display: none; z-index: 9999; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);';
      popup.insertBefore(closeBtn, popup.firstChild);
      document.body.appendChild(popup);
      trigger.style.cssText = 'cursor: pointer;';

      function openPopup() {
        popup.style.display = 'block';
        overlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
      function closePopup() {
        popup.style.display = 'none';
        overlay.style.display = 'none';
        document.body.style.overflow = '';
      }
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPopup();
        }
      });
      overlay.addEventListener('click', closePopup);
      closeBtn.addEventListener('click', closePopup);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.initPdpLengthNoticeIn(document);
  });
})();
